import { useQuery } from '@tanstack/react-query';

import { DatasetColumnContentTypeMapping } from '../../models/dataset.model';

import API from '../../services/api';

import queryKeys from './__queryKeys';

const getDatasetColumnComponentTypes = async (datasetId?: number) => {
    if (!datasetId) return null;
    const { data } = await API.fetchDatasetColumnComponentTypes(datasetId);
    return (data ?? {}) as DatasetColumnContentTypeMapping;
};

export default function useDatasetColumnComponentTypesQuery(
    datasetId?: number,
) {
    return useQuery({
        queryKey: queryKeys.datasetColumnComponentTypes(datasetId),
        queryFn: () => getDatasetColumnComponentTypes(datasetId),
        enabled: !!datasetId,
        staleTime: 60 * 60 * 1000,
    });
}
